import styled from '@emotion/styled';
import { SectionType } from 'components/widget/common/styled';

export const Wrapper = styled.div`
  padding: ${({ theme }) => theme.spacing(3)};
  ${({ theme }) => theme.media.showAt({ to: 1 }) `
    padding: ${theme.spacing(3)} ${theme.spacing(2)};
    overflow: hidden;
  `}
`;

export const BodyWrapper = styled.div`
  flex-direction: column;
  display: flex;
`;

export const TableWrapper = styled.div`
  margin-top: -${({ theme }) => theme.spacing(2)};
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  .pagination {
    flex-grow: 1;
    align-items: flex-end;
  }
`;

export const TableFiltersWrapper = styled.div``;

export const TabsHeaderWrapper = styled.div`
  width: 100%;
  ${({ theme }) => theme.media.showAt({ to: 1 }) `
    margin-bottom: ${theme.spacing(1)};
    overflow: auto;
  `}
`;

export const TabsHeader = styled.div`
  ${({ theme }) => theme.media.showAt({ from: 2 }) `
    display: inline-flex;
    width: auto;
    align-items: center;
    border-bottom: 1px solid ${theme.colors.neutrals.grey8};
    & > div {
      margin-${theme.isRTL ? 'left' : 'right'}: ${theme.spacing(3)};
      &:last-of-type {
        margin: 0;
      }
    }
  `}
  ${({ theme }) => theme.media.showAt({ from: 4 }) `
    & > div {
      margin-${theme.isRTL ? 'left' : 'right'}: ${theme.spacing(4)};
      &:last-of-type {
        margin: 0;
      }
    }
  `}
  ${({ theme }) => theme.media.showAt({ to: 1 }) `
    display: inline-flex;
    align-items: center;
    border-bottom: 1px solid ${theme.colors.neutrals.grey8};
    white-space: nowrap;
  `}
`;

export const TabHeaderWrapper = styled(SectionType)`
  ${({ theme, isActive }) => theme.media.showAt({ to: 1 })`
    border-radius: 0;
    border: none;
    border-bottom: 1px solid ${isActive ? theme.colors.neutrals.grey1 : theme.colors.neutrals.grey8};
    margin-bottom: -1px;
    padding: ${theme.spacing(1)} 0;
    margin-${theme.isRTL ? 'left' : 'right'}: ${theme.spacing(3)};
    > div {
      font-size: 15px;
    }
  `}
`;
